import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { FilterValue, MetricComponent, MetricComponentModel } from 'src/shared/models/pipeline-config/metric-definition.models';
import { ComparisonType, MetricTypes } from 'src/shared/models/pipeline-config/mongo-enums.model';
import PipelineConfigurationService from '../pipeline-configuration.service';

@Component({
    selector: 'metric-component-preview',
    templateUrl: './metric-component-preview.component.html',
    styleUrls: ['./metric-component-preview.component.scss']
})
export class MetricComponentPreviewComponent implements OnInit {

    @Input()
    component: MetricComponent;

    @Input()
    editable: boolean = false;

    @Input()
    metricType: MetricTypes;

    @Output()
    onDelete: EventEmitter<MetricComponent> = new EventEmitter<MetricComponent>();

    @Output()
    onEdit: EventEmitter<MetricComponent> = new EventEmitter<MetricComponent>();

    model: MetricComponentModel;

    constructor(
        private service: PipelineConfigurationService,
        private cvLocalizationService: CVLocalizationService,
    ) { }

    async ngOnInit() {
        if (!this.component)
            console.warn("No component passed to MetricComponentPreview");
        await this.cvLocalizationService.GetSection("Pipeline_Configuration"); // Used for Substring ComparisonType values
        this.model = new MetricComponentModel(this.component, this.metricType);
    }

    /**
     * Emits an event so that this component can be removed from the parent Metric Definition.
     */
    public onDeleteClicked(event: MouseEvent) {
        event.stopPropagation(); // So onCardClicked() doesn't run as well
        if (!this.editable)
            return;

        this.onDelete?.emit(this.component);
    }

    /**
     * Emits an event so that the component can be edited by the Metric Component Modal (opened by Metric Definition parent directive)
     */
    public onCardClicked(event: MouseEvent) {
        if (this.editable === true && this.onEdit != null) {
            this.onEdit.emit(this.component);
        }
    }

    /**
     * Formats a comp value for display. Strings are quoted. The first item is prepended with the comparison type. Subsequent values are comma-separated.
     * Used in a binding expression in the template.
     * @param filterValue The parent of the compValue
     * @param compValue
     * @param isFirst Boolean indicating if the compValue is the first one in its list
     */
    formatCompValue(filterValue: FilterValue, compValue: any, isFirst: boolean) {
        if (!filterValue.IsDate && typeof compValue === "string")
            compValue = `"${compValue}"`;

        if (isFirst) {
            let comparisonType = "";
            switch (filterValue.ComparisonType) {
                case ComparisonType.Contain:
                    comparisonType = this.cvLocalizationService.getCachedText("Pipeline_Configuration", "ComparisonType_Contain", "contains");
                    break;
                case ComparisonType.StartWith:
                    comparisonType = this.cvLocalizationService.getCachedText("Pipeline_Configuration", "ComparisonType_StartWith", "starts with");
                    break;
                case ComparisonType.EndWith:
                    comparisonType = this.cvLocalizationService.getCachedText("Pipeline_Configuration", "ComparisonType_EndWith", "ends with");
                    break;
                default:
                    comparisonType = this.service.displayComparisonTypes[filterValue.ComparisonType];
                    break;
            }
            compValue = `${comparisonType} ${compValue}`;
        } else {
            compValue = `, ${compValue}`;
        }

        return compValue;
    }
}
